(function (root) {
  'use strict';
  function logoUrl(image, usage, item) {
    try {
      const url = new URL(image);
      if (url.protocol !== 'https:' || !/\/public\/champ-logo\/[^/]+\.svg$/.test(url.pathname)) return image;
      url.searchParams.set('usage', usage);
      if (item) url.searchParams.set('item', item);
      else url.searchParams.delete('item');
      return url.href;
    } catch (_) { return image; }
  }
  function prepareMenu(menu, usage, bundled) {
    const next = JSON.parse(JSON.stringify(menu || {}));
    prepareCollegeMenus(next, bundled);
    promotePerformanceMenu(next);
    const byCollection = new Map();
    const collegeHandles = new Set();
    ((bundled && bundled.megamenu) || []).forEach(function (root) {
      const college = (root.menus || []).find(function (node) { return node.setting.title === 'College'; });
      if (college) college.menus.forEach(function (group) {
        (group.menus || []).forEach(function (node) {
          const collection = node.setting.url && node.setting.url.collection;
          if (collection) collegeHandles.add(collection.handle);
        });
      });
    });
    function index(nodes) {
      (nodes || []).forEach(function (node) {
        const setting = node.setting || {};
        const handle = setting.url && setting.url.collection && setting.url.collection.handle;
        const id = setting.artomator_champ_profile_id;
        if (handle && id) {
          const previous = byCollection.get(handle);
          if (!byCollection.has(handle)) byCollection.set(handle, setting);
          else if (previous && previous.artomator_champ_profile_id !== id) byCollection.set(handle, null);
        }
        index(node.menus);
      });
    }
    index(bundled && bundled.megamenu);
    function visit(nodes) {
      (nodes || []).forEach(function (node) {
        const setting = node.setting || {};
        const handle = setting.url && setting.url.collection && setting.url.collection.handle;
        const linked = byCollection.get(handle);
        if (!setting.artomator_champ_profile_id && linked && (setting.image || setting.item_layout === 'image')) {
          setting.artomator_champ_profile_id = linked.artomator_champ_profile_id;
          setting.image = linked.image;
          if (collegeHandles.has(handle) && !setting.artomator_champ_name_profile_id && linked.title) setting.title = linked.title;
        }
        if (setting.artomator_champ_profile_id) setting.image = logoUrl(setting.image, usage, node.id);
        visit(node.menus);
      });
    }
    visit(next.megamenu);
    return next;
  }
  // Keep older Arto-published menus in step with the storefront navigation.
  function promotePerformanceMenu(menu) {
    const roots = menu.megamenu || [];
    roots.filter(function (node) {
      return /^(Mobile - )?Lifestyle$/.test(node.setting && node.setting.title);
    }).forEach(function (lifestyle) {
      const mobile = lifestyle.setting.title === 'Mobile - Lifestyle';
      const title = mobile ? 'Mobile - Performance' : 'Performance';
      const nested = (lifestyle.menus || []).find(function (node) { return node.setting.title === 'Performance'; });
      const existing = roots.find(function (node) { return node.setting.title === title; });
      const performance = existing || nested;
      if (!performance) return;
      lifestyle.menus = (lifestyle.menus || []).filter(function (node) { return node.setting.title !== 'Performance'; });
      // Authored top-level items own their visibility and destination.
      if (existing) return;
      performance.setting = {
        ...performance.setting,
        title: title,
        hidden_desktop: mobile || !!performance.setting.hidden_desktop,
        hidden_mobile: !mobile || !!performance.setting.hidden_mobile,
        disable_link: false,
        hide_submenu: false,
      };
      roots.splice(roots.indexOf(lifestyle) + 1, 0, performance);
    });
  }
  // Upgrade older published menus, retaining Champ-authored names and placement
  // choices. Once a 40-school roster is published, it owns future team swaps.
  function prepareCollegeMenus(menu, bundled) {
    (menu.megamenu || []).forEach(function (root) {
      if (!/^(Mobile - )?Fan Shop$/i.test(root.setting && root.setting.title)) return;
      const college = (root.menus || []).find(function (node) { return node.setting.title === 'College'; });
      const fallbackRoot = ((bundled && bundled.megamenu) || []).find(function (node) { return node.setting.title === root.setting.title; });
      const fallback = fallbackRoot && (fallbackRoot.menus || []).find(function (node) { return node.setting.title === 'College'; });
      if (!college || !fallback) return;
      const groups = college.menus.filter(function (node) { return (node.menus || []).length; });
      const current = groups.flatMap(function (node) { return node.menus; });
      const defaults = fallback.menus.flatMap(function (node) { return node.menus || []; });
      if (defaults.length !== 40 || !groups.length) return;
      const handle = function (node) { return node.setting.url && node.setting.url.collection && node.setting.url.collection.handle; };
      const existing = new Map(current.map(function (node) { return [handle(node), node]; }));
      const roster = current.length === 40 ? current : defaults.map(function (node) {
        return existing.get(handle(node)) || JSON.parse(JSON.stringify(node));
      });
      const mobile = root.setting.hidden_desktop || /^Mobile - /i.test(root.setting.title);
      const size = mobile ? 40 : 8;
      const columns = [];
      for (let i = 0; i < roster.length; i += size) {
        const template = groups[i / size] || fallback.menus[i / size] || groups[0];
        columns.push({ ...template, menus: roster.slice(i, i + size) });
      }
      const firstGroup = college.menus.indexOf(groups[0]);
      const extras = college.menus.filter(function (node) { return !groups.includes(node); });
      extras.splice(firstGroup, 0, ...columns);
      college.menus = extras;
    });
  }
  const api = { logoUrl: logoUrl, prepareMenu: prepareMenu };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.ChampWebsiteLogos = api;
})(typeof window === 'undefined' ? {} : window);
